import { localApi } from "./http";

export type SshConnectionTestRequest = {
    siteId?: number;
    profileId?: number;
    sshHost: string;
    sshPort: number;
    sshUsername: string;
    sshAuthType: "PASSWORD" | "PRIVATE_KEY";
    sshPrivateKeyPath?: string;
    strictHostKeyChecking: boolean;
    password?: string;
    privateKeyPassphrase?: string;
};

export type SshCredentialStatusResponse = {
    hasStoredPassword: boolean;
    persistenceSupported: boolean;
};

export type SshConnectionTestResponse = {
    connected: boolean;
    elapsedMs: number;
    message: string;
};

export const testSshConnection = async (
    request: SshConnectionTestRequest
): Promise<SshConnectionTestResponse> => {
    const response = await localApi.post<SshConnectionTestResponse>(
        "/api/ssh/test",
        request,
        { timeout: 25_000 }
    );
    return response.data;
};

export const updateSshCredential = async (
    profileId: number,
    save: boolean,
    password?: string
): Promise<SshCredentialStatusResponse> => {
    const response = await localApi.put<SshCredentialStatusResponse>(
        `/api/ssh-profiles/${encodeURIComponent(profileId)}/credential`,
        { save, password }
    );
    return response.data;
};

export const getSshCredentialStatus = async (
    profileId: number
): Promise<SshCredentialStatusResponse> => {
    const response = await localApi.get<SshCredentialStatusResponse>(
        `/api/ssh-profiles/${encodeURIComponent(profileId)}/credential`
    );
    return response.data;
};
